import { IconType } from "react-icons/lib";

export type SidebarSection = {
    title: string;
    titleHref?: string;
    Icon: IconType;
    items: SidebarItem[];
};

export type SidebarItems = {
    [key: string]: SidebarSection;
};

export type SidebarItem = {
    name: string;
    Icon?: IconType;
    href?: string;
    onClick?: () => void;
    isSpecial?: boolean;
    showForAdmin?: boolean;
    items?: SidebarItem[];
};

export enum ESidebarItems {
    PROPOSALS = "event-proposals",
    HOST_APPLICATIONS = "host-applications",
    BATCH_EDIT = "batch-edit",
}

export type ModalType =
    | "slug"
    | "badges"
    | "new-event"
    | "settings"
    | "batch-events";
